"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDiff = void 0;
// Packages
var get_edited_paths_1 = require("./get-edited-paths");
var get_paths_diff_1 = require("./get-paths-diff");
var get_struct_paths_1 = require("./get-struct-paths");
var getDiff = function (oldStruct, newStruct, isLodashLike) {
  if (isLodashLike === void 0) {
    isLodashLike = false;
  }
  var delta = {
    added: [],
    removed: [],
    edited: []
  };
  var oldStructPaths = (0, get_struct_paths_1.getStructPaths)(oldStruct, isLodashLike);
  var newStructPaths = (0, get_struct_paths_1.getStructPaths)(newStruct, isLodashLike);
  // A-B
  delta.removed = (0, get_paths_diff_1.getPathsDiff)(oldStructPaths, newStructPaths);
  // B-A
  delta.added = (0, get_paths_diff_1.getPathsDiff)(newStructPaths, oldStructPaths);
  // a->b
  delta.edited = (0, get_edited_paths_1.getEditedPaths)(oldStructPaths, newStructPaths);
  return delta;
};
exports.getDiff = getDiff;